/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BookCheckIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABBElEQVR4nO2Vy0rFMBCGs3LlzsfwsnGhKxcu3OhcukhnKBzwKQR9gvpa+ixe2oKvUIm0UHpI0iYih4MD/6JN+n+dmZAxZm/CWnuALM9A8o6s/RIByxuy1u7bKMBtXGqM26qjgDV/jnORfizJoM+RmfqQvKYDSNs7lhsgffACJs/rAKQtUXXq9jtIMgBI7hHLKyBpJu+a26I8+ekX6BmydOmAQq8Ho2Nk+YyZJ5RIOmc0QpxC5ok9kC/m6nxcD5lnNFk6RL2AorwMmf/eKeJ/AP9BiYD1cdH164kowFp7aDICfYBheLgr4Sk1A+bNUSiDnIHT+3oyG5laj5nkCFhfUiqwm/ENND9KQwKhXawAAAAASUVORK5CYII=)
 */
export const BookCheckIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M15 2a3 3 0 0 1 3 3v12H5.5a1.5 1.5 0 0 0 0 3h14a.5.5 0 0 0 .5-.5V5h1a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h10Zm-.3 5.7a1 1 0 0 0-1.4-1.4L9 10.58l-2.3-2.3a1 1 0 0 0-1.4 1.42l3 3a1 1 0 0 0 1.4 0l5-5Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
